import React from "react";
import { ShieldAlert, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

export default function ConsoleAccessBanner() {
  const { consoleAccess, exitConsoleAccess, exitingConsoleAccess } = useAuth();

  if (!consoleAccess?.active) {
    return null;
  }

  const actingAs = consoleAccess.actingAsName || "store user";
  const openedBy = consoleAccess.platformUser?.name || "Superadmin";

  return (
    <div className="print:hidden border-b border-amber-300/40 bg-amber-50 text-amber-950">
      <div className="mx-auto flex max-w-[1600px] flex-wrap items-center justify-between gap-3 px-4 py-2 text-sm">
        <div className="flex min-w-0 items-center gap-2">
          <ShieldAlert className="h-4 w-4 shrink-0 text-amber-700" aria-hidden />
          <span className="font-medium">Superadmin store access</span>
          <span className="text-amber-800/90">
            Viewing as <strong>{actingAs}</strong> · opened by {openedBy}
          </span>
          <span className="hidden text-[12px] text-amber-700/80 sm:inline">
            The store user&apos;s normal session stays signed in elsewhere.
          </span>
        </div>
        <Button
          type="button"
          size="sm"
          variant="outline"
          className="h-8 border-amber-400 bg-white/70 text-amber-950 hover:bg-white"
          disabled={exitingConsoleAccess}
          onClick={() => exitConsoleAccess()}
        >
          <X className="mr-1 h-3.5 w-3.5" />
          Exit access
        </Button>
      </div>
    </div>
  );
}
